<template>
    <student-backend-focus-layout
        content-bg-color="gray-125"
        exit-button-text="Exit Study Guide"
        v-on:exit-page-clicked="goToStudyGuidesIndex"
        :page-title="studyGuideTitle"
    >
        <template #content>
            <div
                class="flex h-full w-full w-full flex-col items-center justify-start"
            >
                <div
                    class="mb-4 text-[17px] font-semibold text-gray-700 md:hidden"
                >
                    {{ studyGuideTitle }}
                </div>

                <div class="w-full" v-if="pdfSource">
                    <div class="my-4">
                        <a
                            class="btn btn-primary btn-sm"
                            :href="
                                route(
                                    'student.study-guides.open-study-guide-as-pdf',
                                    {
                                        study_guide: studyGuide.id,
                                    }
                                )
                            "
                        >
                            <i class="far fa-print"></i> Download/Print this
                            Study Guide</a
                        >
                    </div>

                    <div
                        class="relative mx-auto w-full max-w-7xl flex-grow bg-white p-4 shadow md:flex-none"
                    >
                        <vue-pdf-embed :source="pdfSource" />
                    </div>
                </div>

                <div v-else>
                    <div
                        class="relative mx-auto w-full max-w-7xl flex-grow bg-white p-4 shadow md:flex-none"
                    >
                        <div class="study-guide-content my-4">
                            <div class="" v-html="studyGuide.content"></div>
                        </div>

                        <div class="my-4">
                            <a
                                class="btn btn-primary btn-sm"
                                :href="
                                    route(
                                        'student.study-guides.open-study-guide-as-pdf',
                                        {
                                            study_guide: studyGuide.id,
                                        }
                                    )
                                "
                            >
                                <i class="far fa-print"></i> Print this Study
                                Guide</a
                            >
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </student-backend-focus-layout>
</template>

<script>
import StudentBackendFocusLayout from "@/_Layouts/NewStudentBackendFocusLayout.vue";
import VuePdfEmbed from "vue-pdf-embed";

export default {
    name: "StudentStudyGuideShow",
    components: { VuePdfEmbed, StudentBackendFocusLayout },
    props: {
        studyGuide: {
            type: Object,
            default: {},
        },
        pdfSource: {
            type: String,
            default: {},
        },
    },
    methods: {
        goToStudyGuidesIndex() {
            this.$inertia.get(route("student.study-guides.index"));
        },
    },
    computed: {
        studyGuideTitle() {
            return this.studyGuide.title;
        },
    },
};
</script>

<style scoped></style>
